import { Box, Grid, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import endpoint from "../../config/endpoints";
import * as myConstClass from "../../config/messageconstant";

import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import {
  noInternetMsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { assignBeatJson } from "../../DynamicFormsJson/Transaction/assignBeat";
import { getAreaByUserType } from "../../Slice/area.slice";
import {
  getBeatBySalesTeamIdAndReportingId,
  setBeatBySalesTeamIdAreaId,
  setBeatList,
} from "../../Slice/beat.slice";
import { getOutletByBeatId } from "../../Slice/outlet.slice";
import {
  getBelowSalesTeamList,
  getSalesExecutiveByUserAndStockHolderType,
  getSalesExecutiveTypeByUserTypeIdsAndAreaId,
} from "../../Slice/salesExecutive.slice";
import {
  getStockStakeHolderByOrderLevelWithSelf,
  getStockStakeHolderType,
} from "../../Slice/stockStakeHolderType.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
class AssignBeatAllowanceWiseForSalesTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salesTeamIds: "",
      reportingManagerId: "",
      setList: [],
      checkList: [],
      isError: false,
      areaName: "",
      salesTeamName: "",
      searchValue: "",
      selection: [],
      selectionForEndUser: [],
      allChecked: false,
      open: false,
      DataToSet: [],
      tabValue: 0,
      tabFlag1: false,
      tabFlag2: true,
      beatAssignationData: {},
      salesExecutivData: {},
      dynamicMasterData: {
        areaDetail: this.props.areaList.areaBySalesTeam,
        reportingManagerDetail: this.props.salesExecutive.salesExecutive,
        salesTeamDetail: this.props.salesExecutive?.salesExecutiveBelowTeam,
        stockStakeHolderTypelistDetail:
          this.props.stockStakeHolderTypeList?.stockStakeHolderType,
      },
      checkedBeatList: [],
      checkedBeatNames: [],
      areaListForName: [],
    };
  }

  a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  handledChange = (e, newValue) => {
    this.setState({
      tabValue: newValue,
      tabFlag1: newValue == 1 ? true : false,
      tabFlag2: newValue == 0 ? true : false,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.stockStakeHolderTypeList !== nextProps.stockStakeHolderTypeList
    ) {
      if (
        this.props.stockStakeHolderTypeList?.stockStakeHolderType !==
        nextProps.stockStakeHolderTypeList?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderTypeDetail:
              nextProps.stockStakeHolderTypeList?.stockStakeHolderType,
          },
        });
      }
    }
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutive !==
        nextProps.salesExecutive?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            reportingManagerDetail: nextProps.salesExecutive?.salesExecutive,
          },
        });
      }
    }
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutiveBelowTeam !==
        nextProps.salesExecutive?.salesExecutiveBelowTeam
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesTeamDetail: nextProps.salesExecutive?.salesExecutiveBelowTeam,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const {
      setBeatBySalesTeamIdAreaId,
      showLoador,
      showNotification,
      getStockStakeHolderType,
      getStockStakeHolderByOrderLevelWithSelf,
    } = this.props;
    if (navigator.onLine) {
      const userTypeId = localStorage.getItem("userTypeId");

      setBeatBySalesTeamIdAreaId({ row: [] });

      if (userTypeId == 1 || userTypeId == 6 || userTypeId == 2) {
        showLoador({ loador: true });
        await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      } else {
        showLoador({ loador: true });
        await getStockStakeHolderByOrderLevelWithSelf().then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getListById = async (data) => {
    const {
      getSalesExecutiveTypeByUserTypeIdsAndAreaId,
      getSalesExecutiveByUserAndStockHolderType,
      showLoador,
      showNotification,
      getBelowSalesTeamList,
    } = this.props;
    if (navigator.onLine) {
      if (data.stockHolderType && data.stockHolderType != "") {
        showLoador({ loador: true });
        await getSalesExecutiveByUserAndStockHolderType({
          stockStakeHolderId: data.stockHolderType,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (data.reportingManagerId && data.reportingManagerId != "") {
        showLoador({ loador: true });
        await getBelowSalesTeamList({
          salesTeamId: data.reportingManagerId,
          flag: 0,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        const salesExecutivData =
          this.props.salesExecutive?.salesExecutive.find(
            (row) => row.id === data.salesExecutive
          );
        this.setState({ salesExecutivData });
      }

      if (data.area && data.area != "") {
        let dataToSave = {
          userTypeIds: [3, 4],
          areaIds: [data.area.id],
        };

        showLoador({ loador: true });
        await getSalesExecutiveTypeByUserTypeIdsAndAreaId({
          dataJson: dataToSave,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearch = (data) => {
    console.log(data);
    const {
      getBeatBySalesTeamIdAndReportingId,
      showLoador,
      showNotification,
      areaList,
      salesExecutive,
    } = this.props;
    if (navigator.onLine) {
      this.setState({
        reportingManagerId: data.reportingManagerId,
        salesTeamIds: data.salesTeamIds,
      });

      let dataToSend = {
        salesTeamIds: data.salesTeamIds.split(","),
        reportingManagerId: data.reportingManagerId,
      };
      showLoador({ loador: true });
      getBeatBySalesTeamIdAndReportingId({ jsonData: dataToSend }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
          }
        }
      );
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  getFormData = () => {
    let tabValue = 1;
    this.setState({
      tabValue: tabValue,
      tabFlag1: tabValue == 1 ? true : false,
    });
  };

  onSubmit = () => {
    const { beatList, showLoador, showNotification } = this.props;
    const { salesTeamIds, reportingManagerId } = this.state;
    let filterBeatList = [];
    let hasError = false;
    let checkedBeatNames = [];

    beatList?.beat.length != 0 &&
      beatList?.beat.map((beatObject) => {
        if (beatObject.isChecked) {
          if (beatObject.isError) {
            hasError = true;
          }

          checkedBeatNames.push(beatObject.beatName);

          const beatListObjectToSave = {
            beat: {
              id: beatObject.beatId,
            },
            salesTeam: {
              id: reportingManagerId,
            },
            beatType: +beatObject.beatType,
            ratePerKm: beatObject.ratePerKm ? +beatObject.ratePerKm : 0,
            dailyAllowance: beatObject.dailyAllowance
              ? +beatObject.dailyAllowance
              : 0,
            distanceFromHq: beatObject.distance ? +beatObject.distance : 0,
            selfAssign:
              beatObject.isSelfAssign == 2
                ? 0
                : beatObject.isCheckedForEndUser
                  ? 1
                  : 0,
          };
          filterBeatList.push(beatListObjectToSave);
        }
      });

    this.setState({ checkedBeatNames, checkedBeatList: filterBeatList });

    let dataToSave = {
      salesTeamIds: salesTeamIds.split(","),
      reportingManagerId: reportingManagerId,
      beatAssigns: filterBeatList,
    };

    this.setState({ beatAssignationData: dataToSave });

    console.log(dataToSave);

    if (!hasError) {
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url: endpoint.assignBeat + "/save-beats-for-manager",
            postBody: dataToSave,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({
                msg: myConstClass.savemsg,
              });
              window.location.reload();
            } else {
              showNotification({
                msg: myConstClass.saveFailedMsg,
                severity: "error",
              });
            }
          });
        }
      });
    }
  };

  onSearchBox = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  handleAllCheckedClick = (e) => {
    const { beatList, setBeatList } = this.props;
    this.setState({ selection: e });
    this.setState({ allChecked: e.target.checked });
    let dataList = beatList?.beat.map((dataObj) => {
      return {
        ...dataObj,
        isChecked: e.target.checked,
      };
    });
    setBeatList({ row: dataList });
  };

  handleClickOnEndUser = (e, id) => {
    const { beatList, setBeatList } = this.props;
    this.setState({ selection: e });
    let data = beatList?.beat.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          isCheckedForEndUser: e.target.checked,
        };
      } else {
        return dataObj;
      }
    });
    setBeatList({ row: data });
  };

  handleClick = (e, id) => {
    const { beatList, setBeatList } = this.props;
    this.setState({ selection: e });
    let data = beatList?.beat.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          isChecked: e.target.checked,
        };
      } else {
        return dataObj;
      }
    });
    setBeatList({ row: data });
  };

  changeRadioHandler = (e, id) => {
    const { beatList, setBeatList } = this.props;

    let data = beatList?.beat.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          beatType: e.target.value,
          ratePerKm: e.target.value == 0 ? 0 : dataObj.ratePerKm,
        };
      } else {
        return dataObj;
      }
    });
    setBeatList({ row: data });
  };

  changeHandler = (row, name) => (e) => {
    const { name, value, placeholder } = e.target;
    const { beatList, setBeatList } = this.props;

    let updatedList = beatList?.beat.map((dataObj) => {
      if (dataObj.id === row.id) {
        return {
          ...dataObj,
          [name]: value,
          [`${name}Error`]:
            value.trim() === "" ? [placeholder] + " cannot be empty" : "",
          isError: value.trim() === "" ? true : false,
        };
      } else {
        return dataObj;
      }
    });

    setBeatList({ row: updatedList });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["beatName"] &&
          currentRow["beatName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["areaName"] &&
          currentRow["areaName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  onCancel = () => {
    window.location.reload();
  };

  render() {
    const { beatList } = this.props;
    const {
      dynamicMasterData,
      allChecked,
      tabValue,
      salesTeamId,
      tabFlag2,
      tabFlag1,
      beatAssignationData,
      salesExecutivData,
      checkedBeatList,
      checkedBeatNames,
      areaListForName,
    } = this.state;
    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            screenTitle={"Beat Configuration Allowance Wise By Sales Teams"}
            showTable={false}
            showBackButton={false}
            showAddButton={false}
            onCancel={this.onCancel}
          />
          {/* <Tabs
                        onChange={this.handledChange}
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example">

                        <Tab
                            disabled={tabFlag1 ? true : false}
                            label={"Form 1"}
                            {...this.a11yProps(0)}
                        />

                        <Tab
                            disabled={tabFlag2 ? true : false}
                            label={"Form 2"}
                            {...this.a11yProps(1)}
                        />

                    </Tabs> */}
          <br />
          <SwipeableViews index={tabValue} onChangeIndex={this.handleChange}>
            <TabPanel value={tabValue} index={0}>
              <DynamicFormWithoutSave
                dynamicMasterData={dynamicMasterData}
                getListById={this.getListById}
                searchList={assignBeatJson.searchList}
                showSaveBtn={true}
                showSaveBtnMain={false}
                showTitle={false}
                screenTitle={""}
                fieldMeta={assignBeatJson.fieldMetaForAllowanceWiseForSalesTeam}
                showCancel={assignBeatJson.showCancel}
                apiBaseURL={assignBeatJson.apiBaseURL}
                showSaveNextBtn={assignBeatJson.showSaveNextBtn}
                saveBtnText={"Search"}
                onSave={this.onSearch}
              />

              {beatList?.beat.length !== 0 && (
                <>
                  <>
                    <LandingScreenHeader
                      screenTitle={""}
                      showSearchBox={true}
                      showTable={true}
                      showFilter={false}
                      showPdfDownload={false}
                      showExcelDownload={false}
                      onSearch={this.onSearchBox}
                    />

                    <div
                      style={{
                        maxHeight: "550px",
                        overflowX: "auto",
                        maxWidth: "100%",
                        borderRadius: "10px",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                        background: "#fff",
                        border: "1px solid #e0e0e0"
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "separate",
                          borderSpacing: 0,
                          fontFamily: "Segoe UI, Arial, sans-serif",
                          fontSize: "15px",
                          background: "#fff",
                        }}
                      >
                        <thead>
                          <tr style={{
                            position: "sticky",
                            top: 0,
                            background: "#f7fafc",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                            zIndex: 2
                          }}>
                            <th style={thStyle}><input type="checkbox" style={{ transform: "scale(1.5)", margin: "0 8px" }}
                              checked={allChecked} onChange={this.handleAllCheckedClick} /></th>
                            <th style={thStyle}>Sr. No.</th>
                            <th style={thStyle}>Beat Name</th>
                            <th style={thStyle}>Beat Distance (KM)</th>
                            <th style={thStyle}>Beat Type</th>
                            <th style={thStyle}>Rate per KM</th>
                            <th style={thStyle}>DA</th>
                            <th style={thStyle}>TA</th>
                            <th style={thStyle}>Total</th>
                            <th style={thStyle}>Sales Team Name</th>
                            <th style={thStyle}>End User</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.getFilteredTableData(beatList?.beat).map((row, index) => (
                            <tr
                              key={row.id}
                              style={{
                                background: index % 2 === 0 ? "#fafbfc" : "#fff",
                                transition: "background 0.2s",
                                borderBottom: "1px solid #eaeaea",
                                cursor: "pointer",
                                ":hover": { background: "#f1f5fa" }
                              }}
                            >
                              <td style={tdCenterStyle}>
                                <input
                                  type="checkbox"
                                  style={{ transform: "scale(1.5)", margin: "0 8px" }}
                                  checked={row.isChecked}
                                  onChange={e => this.handleClick(e, row.id)}
                                />
                              </td>
                              <td style={tdCenterStyle}>{index + 1}</td>
                              <td style={tdStyle}>{row.beatName}</td>
                              <td style={tdInputStyle}>
                                <input
                                  type="number"
                                  name="distance"
                                  value={row.distance}
                                  onChange={e => this.changeHandler(row, "distance")(e)}
                                  placeholder="Beat Distance"
                                  style={inputBoxStyle}
                                />
                                {row.distanceError && (
                                  <div style={errorStyle}>{row.distanceError}</div>
                                )}
                              </td>
                              <td style={tdStyle}>
                                <label style={radioLabelStyle}>
                                  <input
                                    type="radio"
                                    name={`beatType-${row.id}`}
                                    style={{ transform: "scale(1.5)", margin: "0 8px" }}
                                    value="0"
                                    checked={row.beatType == 0}
                                    onChange={e => this.changeRadioHandler(e, row.id)}
                                  />
                                  <span style={radioTextStyle}>Local</span>
                                </label>
                                <label style={radioLabelStyle}>
                                  <input
                                    type="radio"
                                    name={`beatType-${row.id}`}
                                    style={{ transform: "scale(1.5)", margin: "0 8px" }}
                                    value="1"
                                    checked={row.beatType == 1}
                                    onChange={e => this.changeRadioHandler(e, row.id)}
                                  />
                                  <span style={radioTextStyle}>Outstation</span>
                                </label>
                              </td>
                              <td style={tdInputStyle}>
                                <input
                                  type="number"
                                  name="ratePerKm"
                                  value={row.ratePerKm}
                                  onChange={e => this.changeHandler(row, "ratePerKm")(e)}
                                  placeholder="Rate Per KM"
                                  style={inputBoxStyle}
                                  disabled={row.beatType == 0}
                                />
                                {row.ratePerKmError && (
                                  <div style={errorStyle}>{row.ratePerKmError}</div>
                                )}
                              </td>
                              <td style={tdInputStyle}>
                                <input
                                  type="number"
                                  name="dailyAllowance"
                                  value={row.dailyAllowance}
                                  onChange={e => this.changeHandler(row, "dailyAllowance")(e)}
                                  placeholder="DA"
                                  style={inputBoxStyle}
                                />
                                {row.dailyAllowanceError && (
                                  <div style={errorStyle}>{row.dailyAllowanceError}</div>
                                )}
                              </td>
                              <td style={tdRightStyle}>
                                {(+row.ratePerKm * +row.distance).toFixed(2)}
                              </td>
                              <td style={tdRightStyle}>
                                {(
                                  +row.dailyAllowance +
                                  +row.ratePerKm * +row.distance
                                ).toFixed(2)}
                              </td>
                              <td style={tdCenterStyle}>
                                {row.salesTeamName !== "-" ? row.salesTeamName : "-"}
                              </td>
                              <td style={tdCenterStyle}>
                                <input
                                  type="checkbox"
                                  style={{ transform: "scale(1.5)", margin: "0 8px" }}
                                  checked={row.isCheckedForEndUser}
                                  onChange={e => this.handleClickOnEndUser(e, row.id)}
                                  disabled={row.isSelfAssign === 2}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>

                  <br />
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    rowSpacing={2}
                    columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                    container
                    justifyContent="right"
                  >
                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name="Submit"
                      onClick={this.onSubmit}
                    />
                  </Grid>
                </>
              )}
            </TabPanel>
          </SwipeableViews>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  managerList: state.manager,
  areaList: state.area,
  salesExecutive: state.salesExecutive,
  beatList: state.beat,
  outletList: state.outlet,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  stockStakeHolderTypeList: state.stockStakeHolderType,
  salesTeamList: state.salesExecutive,
});
const mapDispatchToProps = {
  getAreaByUserType,
  getSalesExecutiveTypeByUserTypeIdsAndAreaId,
  getBeatBySalesTeamIdAndReportingId,
  getOutletByBeatId,
  showLoador,
  showNotification,
  setBeatBySalesTeamIdAreaId,
  setBeatList,
  getStockStakeHolderByOrderLevelWithSelf,
  getStockStakeHolderType,
  getSalesExecutiveByUserAndStockHolderType,
  getBelowSalesTeamList,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignBeatAllowanceWiseForSalesTeam);

const thStyle = {
  padding: "12px 8px",
  background: "#f7fafc",
  color: "#1a237e",
  fontWeight: 600,
  borderBottom: "2px solid #e0e0e0",
  textAlign: "center",
  fontSize: "15px",
  letterSpacing: "0.02em",
  borderRight: "1px solid #e0e0e0" // Add this line!
};

const tdStyle = {
  padding: "10px 8px",
  borderBottom: "1px solid #eaeaea",
  textAlign: "left",
  fontSize: "15px",
  verticalAlign: "middle",
  borderRight: "1px solid #e0e0e0" // Add this line!
};

const tdCenterStyle = {
  ...tdStyle,
  textAlign: "center"
};

const tdRightStyle = {
  ...tdStyle,
  textAlign: "right"
};

const tdInputStyle = {
  ...tdStyle,
  minWidth: "120px"
};

const inputBoxStyle = {
  width: "90px",
  padding: "4px 8px",
  borderRadius: "4px",
  border: "1px solid #cfd8dc",
  fontSize: "15px",
  outline: "none",
  background: "#f9f9fb"
};

const errorStyle = {
  color: "#e53935",
  fontSize: "12px",
  marginTop: "2px"
};

const radioLabelStyle = {
  marginRight: "12px",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center"
};

const radioTextStyle = {
  marginLeft: "4px"
};